<header>
    <ng-content></ng-content>
    <gx-icon-button
            [icon]="fontSolid.faSignOutAlt"
            class="signout"
            text="Exit"
            (buttonClick)="logoutAsync()"
    ></gx-icon-button>
</header>
